import { collection, doc, serverTimestamp } from 'firebase/firestore'
import type { Firestore } from 'firebase/firestore'
import { deleteDocWithError, setDocWithError } from '../../firestore-mobx/fetch'

export const createAssistantship = (
  firestore: Firestore,
  params: { userId: string; instructorUserId: string }
) => {
  const colRef = collection(
    firestore,
    'user_profile',
    params.userId,
    'instructor'
  )
  const docRef = doc(colRef, params.instructorUserId)

  return setDocWithError(
    docRef,
    {
      userId: params.userId,
      instructorUserId: params.instructorUserId,
      updatedAt: serverTimestamp(),
    },
    { errorName: 'CreateAssistantshipError' }
  )
}

export const deleteAssistantship = (
  firestore: Firestore,
  params: { userId: string; instructorUserId: string }
) => {
  const colRef = collection(
    firestore,
    'user_profile',
    params.userId,
    'instructor'
  )
  const docRef = doc(colRef, params.instructorUserId)

  return deleteDocWithError(docRef, 'DeleteAssistantshipError')
}
